// MpStatusChip — selo único de estado. Mapa fechado abaixo (chaves fixas
// em pt-br/en, com rótulo padrão). Fundo suave + texto escuro. Rótulo
// opcional sobrescreve o padrão. Não substitui selos existentes.
import React from "react";
import { colors, radii } from "./tokens";

const MAP = {
  prospect:   { label: "Prospect",     bg: "#E7F0FA", fg: "#1F4E79" },
  cliente:    { label: "Cliente",      bg: "#E8F5EE", fg: "#1F6B38" },
  ganho:      { label: "Ganho",        bg: "#E8F5EE", fg: "#1F6B38" },
  perdido:    { label: "Perdido",      bg: "#FDECEC", fg: "#A62424" },
  atrasada:   { label: "Atrasada",     bg: "#FDECEC", fg: "#A62424" },
  hoje:       { label: "Hoje",         bg: "#FFF4E0", fg: "#8A5A00" },
  parada_7d:  { label: "Parada 7d",    bg: "#FFF4E0", fg: "#8A5A00" },
  parada_15d: { label: "Parada 15d",   bg: "#FDECEC", fg: "#A62424" },
  pulada:     { label: "Pulada",       bg: "#F3F6F9", fg: "#4A5A6B" },
  cross:      { label: "Ampliação",bg: "#E7F0FA", fg: "#1F4E79" },
};

export default function MpStatusChip({ status, label }) {
  const t = MAP[status] || { label: label || status, bg: colors.neutro[100], fg: colors.neutro[600] };
  return (
    <span
      data-testid={`mp-chip-${status}`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        background: t.bg,
        color: t.fg,
        padding: "4px 10px",
        borderRadius: radii.chip,
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {label || t.label}
    </span>
  );
}
